import ModalService from '/@/modules/core/ui/services/ModalService';
import ReferralModalFactory from '/@/modules/platformreferral/services/ReferralModalFactory';
import { ReferralPromptClickedEventTracking } from '/@/modules/platformreferral/segmentevents/ReferralPromptClickedEventTracking';
import { PlatformReferralSegmentEventProperties } from '/@/modules/platformreferral/constants/PlatformReferralSegmentEventProperties';

export const ShowReferralModalMixin = {
  computed: {
    referralModalComponent() {
      return ReferralModalFactory.build(this.authUser, this.currentEstate);
    }
  },
  methods: {
    onReferFromUserMenu() {
      if (this.isStandardPlan) {
        ReferralPromptClickedEventTracking.dispatch(
          PlatformReferralSegmentEventProperties.ctaLocation.PROFILEMENU
        );
      }

      this.showReferralModal();
    },
    onReferFromBanner() {
      if (this.isStandardPlan) {
        ReferralPromptClickedEventTracking.dispatch(
          PlatformReferralSegmentEventProperties.ctaLocation.BANNER
        );
      }

      this.showReferralModal();
    },
    showReferralModal() {
      ModalService.show({
        parent: this,
        component: this.referralModalComponent,
        width: 400
      });
    }
  }
};
